<!--
 * @Author: ken yang
 * @Date: 2025-04-17 17:31:49
 * @LastEditTime: 2025-04-17 22:10:31
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_pc/src/layout/appHeader/rightMenu/LanguageMenu.vue
-->
<template>
  <el-dropdown
    :teleported="true"
    :hide-timeout="200"
    :popper-class="`dropdown-no-arrow LanguageMenu-popper -m-l-20`"
  >
    <Row class="language-title w-32px h-32px rd-full header-round-hover-bg cursor-pointer" x="c" y="c">
      <IconSvg class="title transition text-white  font-20" name="icon-language" />
    </Row>
    <template #dropdown>
      <Row class="language-header h-42px label text-9b" y="c">
        {{ $t('public.language') }}
      </Row>

      <el-dropdown-menu class="language-list">
        <el-dropdown-item
          v-for="language in configStore.languageMap"
          :key="language.value"
          @click="changeLang(language)"
        >
          <Row class="w-100b" x="sb">
            <span :class="{ 'c-primary': language.value == configStore.locale }">{{ language.label }}</span>
          </Row>
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>
<script setup>
const configStore = useConfigStore()
const changeLang = async (language) => {
  await configStore.setLanguage(language.value)
  await userApi.switchLanguage()
}
</script>
<style lang="scss">
.LanguageMenu-popper.el-popper {
  --el-popper-border-radius: 12px !important;
  border-radius: 12px !important;
  overflow: hidden;
  width: 204px;
  box-sizing: border-box;
}

.LanguageMenu-popper .el-dropdown__list {
  padding: 12px !important;
}

.LanguageMenu-popper .language-header,
.LanguageMenu-popper .language-list {
  width: 100%;
  box-sizing: border-box;
}

.LanguageMenu-popper .language-header {
  padding-right: 12px;
  padding-left: 12px;
}

.LanguageMenu-popper .language-list {
  padding: 0 !important;
}

.LanguageMenu-popper .language-list .el-dropdown-menu__item {
  height: 42px;
  padding-right: 12px !important;
  padding-left: 12px !important;
}

.LanguageMenu-popper .el-dropdown-menu__item:not(.is-disabled):hover {
  --el-dropdown-menuItem-hover-fill: transparent;
  background-color: transparent;
}
</style>
